import {makeStyles} from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    menuHeadStack: {
        height: 18,

        "@media screen and (max-width: 768px)": {
            height: 'auto',
            flexWrap: 'wrap',
            alignItems: 'center',
            rowGap: 4
        },

        "@media screen and (max-width: 480px)": {
            flexWrap: 'noWrap',
        }

    },
    filterIconWrapper: {
        width: 22,
        minWidth: 22,

        '& > svg': {
            width: '100%',
            height: '100%',
            maxWidth: '100%'
        },

        "@media screen and (max-width: 768px)": {
            width: 12,
            minWidth: 12,
        }
    },
    selectComponent: {
        minWidth: 73,
        maxWidth: 75,
        color: theme.palette.secondary.main,
        backgroundColor: "transparent",
        fontSize: 14,
        '& > .MuiInput-input': {
            paddingRight: "2px"
        },
        '&:hover:not(.Mui-disabled, .Mui-error):before': {
            borderColor: theme.palette.mainButton.blue
        },
        '&:before': {
            borderColor: theme.palette.secondary.main,
        },
        '&.Mui-focused': {
            color: theme.palette.mainButton.blue,

            '&:after': {
                borderColor: theme.palette.mainButton.blue,
                borderWidth: 1
            }
        },

        '& .MuiSelect-select p': {
            margin: 0
        },

        "@media screen and (max-width: 768px)": {
            height: 18,
            maxWidth: 'none',
            width: 'calc(48% - 12px)',
        }
    },
    menuItem: {
        '&.Mui-selected': {
            backgroundColor: theme.palette.secondary.light
        },
        '& .MuiTypography-root': {
            fontSize: 12,
            textWrap: "balance"
        },
        color: theme.palette.mainButton.dark,
        //padding: "8px 10px",
        padding: "4px 2px 4px 2px",
        maxHeight: 22
    },
}));

export default useStyles;
